const zyurl = url => {
  return localStorage.getItem('zyUrl') + '/api' + url
}
const cpurl = url => {
  return localStorage.getItem('cpUrl') + '/api' + url
}

export default {
  writeLog: window.ConfigNew.opUrl + '/Push/WriteLog', // 埋点
  sso: zyurl('/passport/loginHeart'), // 单点登录

  // login
  preLogin: window.ConfigNew.preUrl + '/PreLanding/preLogin', // 预登陆
  login: zyurl('/menus/unifyLogin'), // 登录
  fpSendMsg: zyurl('/FrontendStudents/sendMessageOfPassword'), // 找回密码 - 获取验证码
  fpGetVerify: zyurl('/FrontendStudents/verifyNum'), // 找回密码 - 校验验证码
  fpResetPwd: zyurl('/FrontendStudents/getBackPassword'), // 找回密码 - 重置密码
  activation: zyurl('/studentAccount/activation'), // VIP激活
  getCountry: zyurl('/citys/getCountryList'), // 获取地区
  getSchoolByCountryIdStu: zyurl('/schools/getSchoolListByCountryIdStu'), // 获取学校
  getGradeBySchoolIdNoCount: zyurl('/categorys/getGradeListBySchoolIdNoCount'), // 获取年级
  getClassByCategoryId: zyurl('/category_classlists/getClassByCategoryId'), // 获取班级
  savePerStuInfo: zyurl('/students/savePerStuInfo'), // 完善信息

  // student
  getStudentInfo: zyurl('/students/stuInfo'), // 获取学生信息
  studentInfo: zyurl('/students/info'), // 获取学生VIP信息
  logout: zyurl('/students/logout'), // 登出
  getPromotion: zyurl('/promotions/getPromotionNoticeByStuId'), // 晋级列表
  readPromotion: zyurl('/promotions/setPmnReaded'), // 设置晋级弹窗已读
  checkNewTask: zyurl('/StudentMessage/newTaskCompetition'), // 新练习新测评
  setPromoteNoticeReaded: zyurl('/students/setPromoteNoticeReaded'), // 标记升年级信息已读
  addOneFeedback: zyurl('/feedbacks/addOneFeedback'), // 侧边栏 - 意见反馈
  unreadNotice: cpurl('/competitionsNotices/countUnreadNotice'), // 未读消息数量
  permission: zyurl('/auths/permission'), // 获取当前学生是否处于禁用状态， 全部为vip续期页面,
  loginHeart: zyurl('passport/loginHeart'), // 修改密码踢出账号
  // 设备检测
  writeDevice: zyurl('/student_device/writeDevice'), // 设备检测 - 更新
  readDevice: zyurl('/student_device/readDevice'), // 设备检测 - 读取
  // 支付
  getProductList: zyurl('/jdcp/getProductList'), // 获取产品
  payInfo: zyurl('/jdcp/payInfo'), // 支付信息
  checkPay: cpurl('/payApi/checkPaymentStatusNew'), // 检查支付
  // 首页
  getTodoBanner: zyurl('/practices/getTodoBannerPractice'), // 首页 - 待完成大赛列表 banner
  getTodoList: zyurl('/practices/getAllTodoPracticeNative'), // 首页 - 待完成练习列表
  setJoinTime: cpurl('/WebCompetition/setJoinTime'), // 测评报名
  speakingStar: zyurl('/practices/getThisWeekRank'), // 首页 - 口语之星
  classVoice: zyurl('/practices/getLastWeekRank'), // 首页 - 班级好声音
  getSubmitLog: zyurl('/practices/getSubmitLog'), // 班级动态
  checkPopup: zyurl('/Popups/checkPopup'), // 检查弹窗是否存在
  setNotAlert: zyurl('/Popups/setNotAlert'), // 设置弹窗不再提示
  getTaskList: cpurl('/HolidayTasks/getTaskList'), // 假期作业列表
  // 测评详情
  getCompetitionDetail: zyurl('/englishCompetitions/getCompetitionDetail'), // 测评详情
  getCompetitionRanking: zyurl('/englishCompetitions/ranking'), // 测评排名
  getCompetitionReport: cpurl('/MEnglishCompetition/getCompetitionReport'), // 获取报告购买状态
  // 自学试卷列表
  getSelfLearnPaper: zyurl('/EnglishCompetitions/getSelfLearnPaper'), // 获取自学试卷列表
  // 错题本
  checkCustomTagAlert: zyurl('/students/checkCustomTagAlert'), // 检查自定义窗口记住状态
  addCustomTagAlert: zyurl('/students/addCustomTagAlert'), // 记住自定义窗口状态
  getLowScoreZy: zyurl('/wrongs/getLowScoreList'), // 错题本列表 - 练习
  addLowScoreZy: zyurl('/wrongs/addLowScore'), // 加入错题本 - 练习
  delLowScoreZy: zyurl('/wrongs/deleLowScore'), // 删除错题本 - 练习
  getLowScoreCp: cpurl('/CollectLowScore/getLowScoreList'), // 错题本列表 - 测评
  addLowScoreCp: cpurl('/wrongs/addLowScore'), // 加入错题本 - 测评
  delLowScoreCp: cpurl('/CollectLowScore/deleLowScore'), // 删除错题本 - 测评
  correct: cpurl('/CollectLowScore/correct'), // 用来处理超过70分显示订正
  correctZy: zyurl('/Wrongs/correct'),
  // 收藏集
  getVocabList: zyurl('/vocabs/getVocabList'), // 收藏集列表 - 练习
  insertOneVocab: zyurl('/vocabs/insertOneVocab'), // 加入收藏集 - 练习
  deleteOneVocab: zyurl('/vocabs/deleteOneVocab'), // 删除收藏集 - 练习
  getCollectionsList: cpurl('/CollectLowScore/getCollectionsList'), // 收藏集列表 - 测评
  addCollections: cpurl('/CollectLowScore/addCollections'), // 加入收藏集 - 测评
  deleCollections: cpurl('/CollectLowScore/deleCollections'), // 删除收藏集 - 测评
  // 音标学习
  ybxxList: zyurl('/SymbolStudy/getList'), // 音标学习列表
  // 听说考试
  tsksList: cpurl('/lst_tsks/index'), // 听说考试列表
  // 专项训练
  zxxlList: cpurl('/lst_zxxl/index'), // 专项训练分类列表
  zxxlCatgList: cpurl('/lst_zxxl/dictCatgList'), // 专项训练列表
  // 话题项目
  courseListP: cpurl('/lst_htxm/courseListP'), // 获取话题列表 一级
  courseListC: cpurl('/lst_htxm/courseListC'), // 获取话题列表 二级
  htxmList: cpurl('/lst_htxm/index'), // 话题项目列表 话题项目测评获取题目
  // 视听说
  stsList: cpurl('/es_sts/index'), // 视听说列表 视听说测评获取题目
  // 情景对话
  // 口头作文
  cjzwList: cpurl('/es_cjzw/index'), // 口头作文列表
  // 同步练习
  getStuBook: zyurl('/SynPractice/getStuBook'), // 同步练习 - 根据学生，获取书本和单元信息
  getContent: zyurl('/SynPractice/getContentByUnit'), // 同步练习 - 根据单元获取section和内容
  getSearchCond: zyurl('/SynPractice/getSearchCond'), // 同步练习 - 添加书本 - 获取筛选下拉
  getBookList: zyurl('/SynPractice/listBookForAddNew'), // 同步练习 - 添加书本 - 获取书本列表接口
  bindStuBook: zyurl('/SynPractice/bindStuBook'), // 同步练习 - 添加书本 - 学生绑定书本
  unbindStuBook: zyurl('/SynPractice/unbindStuBook'), // 同步练习 - 添加书本 - 学生删除书本
  addSelfLearn: zyurl('/self_learn_tmps/addOneSelfLearn'), // 同步练习 - 添加一次自学
  // 成长记录
  statisticalTime: zyurl('/LearningRecordCp/defaultDate'), // 统计时间
  workBasic: zyurl('/worksets/getOneStuReportBasic'), // 获取练习统计信息
  workReport: zyurl('/records/getOneStuReportCurve'), // 获取练习统计图表
  workList: zyurl('/records/getStudentWorksetList'), // 获取练习列表
  examBasic: zyurl('/learningRecordCp/summary'), // 获取测评统计信息
  examReport: zyurl('/learningRecordCp/chart'), // 获取测评统计图表
  examList: zyurl('/Growup/history'), // 获取测评列表
  t2sRecord: zyurl('/LearningRecordCp/bx_jypg'), // 结业评估
  // 听说宝典
  // 消息中心
  getNoticeList: cpurl('/competitionsNotices/noticeList'), // 消息中心 - 消息列表
  readAllNotice: cpurl('/competitionsNotices/setAllNoticeRead'), // 消息中心 - 所有已读
  getOneNotice: cpurl('/competitionsNotices/getOneNotice'), // 消息中心 - 获取一个消息详情
  // 个人资料
  uploadAvatar: zyurl('/uploads/addStuHeadPic'), // 个人资料 头像上传
  sendMessageOfPassword: zyurl('/FrontendStudents/sendMessageOfPassword'), // 个人资料 获取验证码
  phoneCertified: zyurl('/FrontendStudents/phoneCertified'), // 个人资料 认证手机号
  saveStuInfo: cpurl('/WebCompetition/saveStuInfo'), // 个人资料 保存个人信息
  getMyCertificate: cpurl('/mEnglishCompetition/getMyCertificate'), // 个人资料 证书列表
  modifyPassword: zyurl('/FrontendStudents/modifyPassword'), // 个人资料 修改密码
  // 测评
  checkUserBehavior: zyurl('/UserBehavior/checkUserBehavior'), // 检查用户一些行为是否要显示
  setUserBehavior: zyurl('/UserBehavior/setUserBehavior'), // 设置用户行为不再弹窗（或已读）
  getCompetitionInfo: cpurl('/MEnglishCompetition/getCompetitionInfo'), // 获取测评信息
  getPaperAnswer: zyurl('/submitCompetition/getAutoSave'), // 获取测评进度
  savePaperAnswer: zyurl('/submitCompetition/AutoSave'), // 保存测评进度
  delePaperAnswer: zyurl('/submitCompetition/deleAutoSave'), // 删除测评进度
  getPaperInfo: cpurl('/WebCompetition/getPaperInfo'), // 获取试卷信息
  preload: cpurl('/papers/preload'), // 测评 - 音频预加载
  startCompetition: cpurl('/SubmitCompetition/startCompetition'), // 开始测评
  checkIsCollection: cpurl('/CollectLowScore/checkIsCollection'), // 批量判定是否加入收藏
  collectionsPractice: cpurl('/CollectLowScore/collectionsPractice'), // 收藏本测评获取题目
  lowScorePractice: cpurl('/CollectLowScore/lowScorePractice'), // 错题本测评获取题目
  submitPaperAnswer: cpurl('/SubmitCompetition/submit'), // 提交试卷
  // 练习
  getTaskListByWSId: zyurl('/tasks/getTaskListByWSId'), // 获取练习包
  getServerDate: zyurl('/students/getServerDate'), // 获取服务器时间
  addOneTaskRecord: zyurl('/records/addOneTaskRecord'), // 提交练习
  updateSymbolScore: zyurl('/SymbolStudy/updateSymbolScore'), // 练习 - 音标学习分数更新
  getDetailReportByStuIdWSId: zyurl('/records/getDetailReportByStuIdWSId'), // 练习 - 获取练习报告
  setKeyBoardFlag: zyurl('/checkAlerts/setReciteKeyBoardFlag'), // 设置键盘提示不再显示
  getKeyBoardFlag: zyurl('/checkAlerts/getReciteKeyBoardFlag'), // 获取键盘提示是否不再显示
  getConfusedSymbolInfo: zyurl('/InitResource/getConfusedSymbolInfo'), // 获取音标字典表 - 易混淆发音
  getSymbolInfo: zyurl('/InitResource/getSymbolInfo'), // 获取音标字典表
  gradeStage: cpurl('/paperConfigure/gradeStage'),
  courses: cpurl('/courses/index'),
  gradeBaseList: cpurl('/paperConfigure/gradeBaseList'),
  // 教研首页
  settingInfo: zyurl('/setting/info'), // 首页介绍模板
  zxpxSave: zyurl('/Zxpx/save'),
  getCompetitionListDetail: zyurl('/EnglishCompetitions/getCompetitionListDetail'), // 教研首页banner

  // 专题培训列表
  zxpxGetList: zyurl('/Zxpx/getList'),
  edit: zyurl('/setting/edit'), // 教师研训平台配置设置编辑

  checkPracticeAgain: zyurl('/Students/isVipOnlyOnceWorkset'), // 非VIP用户是否还能继续答题

  // 我的书本
  bindbook: cpurl('/QrCode/getStuBinded'), // 绑定书本
  myPaperBooks: cpurl('/QrCode/myPaperBooks'), // 获取书本
  myBindingCmps: cpurl('/QrCode/myBindingCmps'), // 获取测评列表

  // 加入班级
  validateClassCode: zyurl('/student/auth/validateClassCode'),
  authStore: zyurl('/student/auth/store'),

  // 报刊学习
  getPaperList: cpurl('/NewsPaperApp/getPaperList'),
  getPeriods: cpurl('/NewsPaperApp/getPeriods'),
  getModules: cpurl('/NewsPaperApp/getModules'),
  getActiveList: cpurl('/NewsPaperApp/getActiveList'),
  getUpToken: cpurl('/StudentApp/getUpToken'),
  addActivityWork: cpurl('/NewsPaperApp/addActivityWork'),
  giveLike: cpurl('/NewsPaperApp/giveLike'),
  getBanner: cpurl('/NewsPaperApp/getBanner'),
  getAuditStatus: cpurl('/NewsPaperApp/getAuditStatus')
}



// WEBPACK FOOTER //
// ./src/api/Api.js